"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiState = void 0;
class AiState {
    constructor(selfId, __typeName, args) {
        this.selfId = selfId;
        this.__typeName = __typeName;
        this.args = args;
        this.meta = {};
    }
}
exports.AiState = AiState;
